import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface ConfirmRequest {
  /** The question, phrased so the confirm button is the answer to it. */
  title: string;
  /** What the deletion costs — say it where it is not obvious or not recoverable. */
  body?: string;
  confirmLabel?: string;
}

/**
 * One dialog, asked for from anywhere and awaited like a value.
 *
 * A deletion in the workbench removes something a handler entered or a document the
 * case was assessed on, so it asks first. Only pressing the confirm button resolves
 * true: dismissing, cancelling and Escape all resolve false, because a dialog got rid
 * of by accident must never be read as consent.
 */
export const useConfirmStore = defineStore('confirm', () => {
  const pending = ref<ConfirmRequest | null>(null);
  let settle: ((confirmed: boolean) => void) | null = null;

  function ask(request: ConfirmRequest): Promise<boolean> {
    settle?.(false);
    pending.value = request;
    return new Promise((resolve) => {
      settle = resolve;
    });
  }

  function answer(confirmed: boolean): void {
    pending.value = null;
    settle?.(confirmed);
    settle = null;
  }

  return { pending, ask, answer };
});
